// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M1 2.5H9.48062L11.4806 5H23V13.8464C21.8077 12.4127 20.0104 11.5 18 11.5C14.4101 11.5 11.5 14.4102 11.5 18C11.5 19.0821 11.7644 20.1025 12.2322 21H1V2.5Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M23.9083 18.0021L19.05 13.0879L17.6277 14.494L20.1073 17.0021L12.998 17.0021V19.0021L20.1073 19.0021L17.6277 21.5102L19.05 22.9163L23.9083 18.0021Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-folder-export-filled')
export default class FolderExportFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'folder-export-filled',
    }
  }
}
